import React from 'react';
import PageTransition from '@/components/page-transition/PageTransition';
import classes from './services.module.scss';
import Text from '@/components/text/text';
import Hero from '@/components/hero/hero';
import StructuredData from './structured-data';
import Contact from '@/components/contact/contact';
import ContentArea from '@/components/content-area/content-area';
import SplitContent from '@/components/split_content/split_content';
import Button from '@/components/button/button';
import Link from 'next/link';
import Strategy from '@/components/icons/strategy';
import Performance from '@/components/icons/performance';
import Data from '@/components/icons/data';
import Training from '@/components/icons/training';

export default function Services() {

  return (
    <>
      <StructuredData />
      <PageTransition>
        <main className={classes.wrapper}>
          <div className={'body-bg'}></div>
          <Hero
            title='Our services' />
          <ContentArea hero>
            <>
              <SplitContent>
                <>
                  <Text type={'h5'} column={0}>Our <Link scroll={false} href="/strategy" >digital strategy</Link> services are designed to empower your organisation and propel you towards your goals.</Text>
                  <Text type={'p'} column={0}>We combine industry expertise, data-driven strategies, and innovative technologies to deliver customised solutions tailored to your business needs.</Text>

                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Strategy</Text>
              <Strategy isActive duration={1} isPrevActive={false} feature small />
              <SplitContent>
                <>
                  <div>
                    <Text type={'h5'} column={0}>Strategy is the foundation of success in the digital landscape. </Text>
                    <Button link="/strategy" title="View Strategy" serviceButton style="primary" column={1} />
                  </div>
                  <div>
                    <Text type={'p'} column={0}>With our comprehensive audience planning, industry research, and competitor analysis, we gather the insights needed to create a roadmap for your success.</Text>
                    <Text type={'p'} column={0}>By combining our deep understanding of your business with data-driven strategies, we develop a <Link scroll={false} href="/strategy" >digital strategy</Link> that aligns with your objectives and sets you apart from the competition.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Performance</Text>
              <Performance isActive duration={1} isPrevActive={false} feature small />
              <SplitContent>
                <>
                  <div>
                    <Text type={'h5'} column={0}>Our performance solutions combine SEO, paid social ads, and Google Ads to boost your brand.</Text>
                    <Button link="/performance" title="View Performance" serviceButton style="primary" column={1} />
                  </div>
                  <div>
                    <Text text={" "} type={'p'} column={0}>We use data insights to maximize ROI and help you outshine competitors.</Text>
                    <Text type={'p'} column={0}>By leveraging data-driven insights and implementing strategic optimizations, we work hard to ensure that your return on investment is maximised, assisting you in outperforming your competition.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Data & Analytics</Text>
              <Data isActive duration={1} isPrevActive={false} feature small />
              <SplitContent>
                <>
                  <div>
                    <Text type={'h5'} column={0}>Our data and analytics services centre around harnessing the power of cutting-edge tools.</Text>
                    <Button link="/data" title="View Data & Analytics" serviceButton style="primary" column={1} />
                  </div>
                  <div>
                    <Text type={'p'} column={0}>Our primary toolkit consists of Google Analytics, Google Tag Manager, and Google Looker Studio.</Text>
                    <Text type={'p'} column={0}>We&rsquo;ll assist you in implementing, configuring, and leveraging these tools to meticulously track and measure key metrics, gain actionable insights, and optimise your digital marketing efforts for maximum impact.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium' >Training</Text>
              <SplitContent>
                <>
                  <div>
                    <Text text={" "} type={'h5'} column={0}>We help businesses unlock their full potential in sports digital marketing.</Text>
                    <Button link="/training" title="View Training" style="primary" serviceButton column={1} />
                  </div>
                  <div>
                    <>
                      <Text type={'p'} column={0}>Our custom trainings are designed to give your team mastery in digital tools like social media, SEO, and Google Analytics 4.</Text>
                      <Text type={'p'} column={0}>With our hands-on approach, your team will be equipped to lead in sports digital marketing. Using a mix of creativity, expertise, and data, we&rsquo;re  dedicated to propelling your brand to the forefront. </Text>
                      <Text type={'p'} column={0}>Get in touch today to see how we can amplify your brand&rsquo;s digital impact.</Text>
                    </>
                  </div>
                </>
              </SplitContent>
              <Training isActive duration={1} isPrevActive={false} feature small />
            </>
          </ContentArea>

          <Contact />


        </main>
      </PageTransition>
    </>
  )
}
